import React from 'react';

// eslint-disable-next-line @nx/workspace/no-restricted-imports-clone
import { Collapse as ChakraCollapse, forwardRef } from '@chakra-ui/react';

import { CollapseProps } from './types/collapse-props';

export const Collapse = forwardRef<CollapseProps, 'div'>((props, ref) => {
  return <ChakraCollapse ref={ref} {...props} />;
});
